import SPENDING_CATEGORIES from '../definitions/SpendingCategories';
import DEFAULT_CARD_PREFERENCES from '../definitions/DefaultCardPreferences';
import getSumOfObjectValues from './getSumOfObjectValues';


/**
 * Gets the monthlySpending values based on a new monthlySpendingAverage.
 * If every value in the monthlySpending object is NaN or null, uses the default
 * values from DEFAULT_CARD_PREFERENCES.monthlySpending
 * @param {number} monthlySpendingAverage - The new monthly spending average.
 * @param {MonthlySpendingCategories} [monthlySpendingCategories] - contains monthly spending values for each spending category.
 * @returns {MonthlySpendingCategories} - The updated monthly spending object.
 */
function getMonthlySpendingFromAverage(monthlySpendingAverage, monthlySpendingCategories) {
    let updatedMonthlySpending = {};

    // If all values are 0 or NaN, use the default values to generate the ratio from monthlySpendingAverage
    if (
        !monthlySpendingCategories
        || Object.values(monthlySpendingCategories).every(val => isNaN(val) || val === 0)
    ) {
        updatedMonthlySpending = { ...DEFAULT_CARD_PREFERENCES.monthlySpending };
    } else {
        updatedMonthlySpending = { ...monthlySpendingCategories };
    }

    // Calculate the portion needed to convert the monthlySpendingAverage to the new average
    const proportion = monthlySpendingAverage / getSumOfObjectValues(updatedMonthlySpending);

    // Calculate the new monthlySpendingCategories values by multiplying categories proportionally to new average
    Object.keys(updatedMonthlySpending).forEach(key => {
        updatedMonthlySpending[key] = Math.round(updatedMonthlySpending[key] * proportion) || 0;
    });

    // Add any remainders from ratio calculation to the OTHER category
    updatedMonthlySpending[SPENDING_CATEGORIES.OTHER] += monthlySpendingAverage - getSumOfObjectValues(updatedMonthlySpending);

    return updatedMonthlySpending;
}

export default getMonthlySpendingFromAverage;
